"use strict";
/*
 * Copyright (C) 2020 Graylog, Inc.
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the Server Side Public License, version 1,
 * as published by MongoDB, Inc.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * Server Side Public License for more details.
 *
 * You should have received a copy of the Server Side Public License
 * along with this program. If not, see
 * <http://www.mongodb.com/licensing/server-side-public-license>.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var THEME_BASE_1 = require("../../THEME_BASE");
var colors_1 = require("../../utils/colors");
var LIGHT_THEME_COLOR_RATIO = [0.22, 0.55, 0.88];
var DARK_THEME_COLOR_RATIO = [0.15, 0.55, 0.95];
var generateVariantColors = function (colorScheme, colors) {
    if (![THEME_BASE_1.COLOR_SCHEME_DARK, THEME_BASE_1.COLOR_SCHEME_LIGHT].includes(colorScheme)) {
        throw new Error("Requires \"".concat(THEME_BASE_1.COLOR_SCHEME_DARK, "\" or \"").concat(THEME_BASE_1.COLOR_SCHEME_LIGHT, "\" color scheme option."));
    }
    var adjustLight = colorScheme === THEME_BASE_1.COLOR_SCHEME_DARK ? colors_1.darken : colors_1.lighten;
    var adjustDark = colorScheme === THEME_BASE_1.COLOR_SCHEME_DARK ? colors_1.lighten : colors_1.darken;
    var ratio = colorScheme === THEME_BASE_1.COLOR_SCHEME_DARK ? DARK_THEME_COLOR_RATIO : LIGHT_THEME_COLOR_RATIO;
    var variantBaseColors = Object.fromEntries(Object.entries(colors).map(function (_a) {
        var variantName = _a[0], color = _a[1];
        return ([variantName, color]);
    }));
    var variantColorShades = {
        light: {}, lighter: {}, lightest: {}, dark: {}, darker: {}, darkest: {},
    };
    Object.entries(colors).forEach(function (_a) {
        var name = _a[0], baseColor = _a[1];
        variantColorShades.light[name] = adjustLight(baseColor, ratio[0]);
        variantColorShades.lighter[name] = adjustLight(baseColor, ratio[1]);
        variantColorShades.lightest[name] = adjustLight(baseColor, ratio[2]);
        variantColorShades.dark[name] = adjustDark(baseColor, ratio[0]);
        variantColorShades.darker[name] = adjustDark(baseColor, ratio[1]);
        variantColorShades.darkest[name] = adjustDark(baseColor, ratio[2]);
    });
    return __assign(__assign({}, variantBaseColors), variantColorShades);
};
exports.default = generateVariantColors;
